import Phaser from 'phaser'
import { SCENE_KEYS } from '../types'

export class LoadingScene extends Phaser.Scene {
  constructor() {
    super({ key: SCENE_KEYS.LOADING })
  }

  preload() {}

  create() {}
}
